import Vue from "vue";
import Vuex from "vuex";
import axios from 'axios';
import api from "./constants/api";
import io from "socket.io-client";
import new_passenger_registered from "@/assets/new_passenger_registered.mp3";
import {setMomentTime} from "@/util";

Vue.use(Vuex);


export default new Vuex.Store({
    state: {
        user: JSON.parse(localStorage.getItem('user')),
        notifications: JSON.parse(localStorage.getItem('notifications')) || [],
        socket: null,
        ai_status: {
            snoozed_at: null,
            snooze_interval: 0,
            dispatch_interval: 0,
            ai_stopped: '0'
        }
    },
    mutations: {
        SET_ONLINE(state, value) {
            state.user = Object.assign({}, state.user, {online: value})
        },
        SET_AI_STATUS(state, status) {
            state.ai_status = status;
        },
        LOGIN(state, user) {
            state.user = user;
            setMomentTime(user.timestamp);
            axios.defaults.headers.common['Authorization'] = `Bearer ${user.accessToken}`;
            localStorage.setItem('user', JSON.stringify(user));
        },
        LOGOUT(state) {
            try {
                axios.defaults.headers.common['Authorization'] = ``;
                state.user = null;
                localStorage.removeItem('user');
                localStorage.removeItem('notifications');
                if (state.socket) state.socket.disconnect();
            } catch (e) {
                console.log(e);
            }
        },
        NEW_NOTIFICATION(state, notification) {
            state.notifications = [...state.notifications, notification];
            localStorage.setItem('notifications', JSON.stringify(state.notifications));
        },
        INIT_SOCKET(state) {
            state.socket = io(api.SOCKET.USERS, {
                transportOptions: {
                    polling: {
                        extraHeaders: axios.defaults.headers.common
                    }
                }
            });
            state.socket.on('error', (err) => console.log('SOCKET ERROR', err));

            //TODO: disable receive notifications for specific roles, it must be as permission

            if (state.user && [11, 12].includes(state.user.roles[0].id)) {
                state.socket = {};
                return;
            }

            state.socket.on(api.SOCKET.EVENTS.NEW_NOTIFICATION, ({message, datetime = +new Date(), color = 'orange'}) => this.commit('NEW_NOTIFICATION', {
                message,
                color,
                datetime
            }));
            state.socket.on('Ai:status_updated', ai_status => this.commit('SET_AI_STATUS', ai_status));
            state.socket.on('Dashboard:new_passenger', (passenger) => {
                const withDocs = !!(passenger.id_card_front || passenger.id_card_back);
                this.commit("NEW_NOTIFICATION", {
                    color: "grey",
                    message: `New Passenger ${passenger.first_name} ${passenger.last_name} ${withDocs ? "With Docs" : "Without Docs"}`,
                    datetime: +new Date()
                });
                (new Audio(new_passenger_registered)).play();
            });
        }
    },
    actions: {
        async validateToken({commit, state},token = null) {
            try {
                let baseUser;
                if (!token) {
                    baseUser = state.user;
                    token = baseUser.accessToken;
                } else {
                    baseUser = {
                        accessToken: token
                    }
                }


                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                const {data: {data: user}} = await axios.get(api.ACTIONS.CHECK_TOKEN);
                await commit('LOGIN', Object.assign({}, baseUser, user));
                await commit('SET_AI_STATUS', user.ai_status);
            } catch (e) {
                commit('LOGOUT');
            }
        },
        initSocket({commit, state}) {
            if (state.socket) state.socket.disconnect();
            commit('INIT_SOCKET');
        }
    }
});
